/* DHC v1053.42 B116 — big-box delivery window rendering */
(function(){
  function nextBusinessDay(d){
    var out=new Date(d.getFullYear(),d.getMonth(),d.getDate());
    do{out.setDate(out.getDate()+1);}while(out.getDay()===0||out.getDay()===6);
    return out;
  }
  function addBusinessDays(d,days){
    var out=new Date(d.getFullYear(),d.getMonth(),d.getDate());
    var added=0;
    while(added<days){
      out.setDate(out.getDate()+1);
      if(out.getDay()!==0&&out.getDay()!==6){added++;}
    }
    return out;
  }
  function formatDate(d){
    return d.toLocaleDateString(undefined,{month:'short',day:'numeric'});
  }
  function getWindow(mode,start){
    if(mode==='usa'){
      return {early:addBusinessDays(start,2),late:addBusinessDays(start,5)};
    }
    return {early:addBusinessDays(start,3),late:addBusinessDays(start,10)};
  }
  function hydrate(root){
    (root||document).querySelectorAll('[data-dhc-delivery-window]').forEach(function(el){
      var holder=el.closest('[data-dhc-fulfillment]');
      var mode=holder && holder.getAttribute('data-dhc-window')==='usa' ? 'usa' : 'intl';
      var start=nextBusinessDay(new Date());
      var range=getWindow(mode,start);
      el.textContent=formatDate(range.early)+'–'+formatDate(range.late);
    });
  }
  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',function(){hydrate(document);});
  }else{hydrate(document);}
  document.addEventListener('shopify:section:load',function(e){hydrate(e.target);});
})();
